import React from 'react';
import { useForm } from "react-hook-form";
import { loginUser } from '../../store/auth'
import {useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { useSelector } from 'react-redux';
import { getImagePath } from '../../utils/imagePath';
const Login = () => {
    const { t } = useTranslation()
    const { register, handleSubmit, formState: { errors } } = useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const login_loading = useSelector(state=>state.auth.login_loading)
    const {login} = useAuth()
    const logToFile = (message) => {
        const logData = {
            timestamp: new Date().toISOString(),
            message: message,
            pathname: window.location.pathname,
            token: localStorage.getItem('token') ? 'EXISTS' : 'NOT_FOUND'
        };
        console.log('[LOGIN]', logData);
        // Also try to send to server for logging
        try {
            fetch('/api/api/log-client.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(logData)
            }).catch(() => {}); // Ignore errors
        } catch (e) {}
    };

    const onSubmit = async (data) => {
        logToFile('Login attempt started - Username: ' + data.username);
        try {
            const response = await dispatch(loginUser(data)).unwrap();
            logToFile('Login API response received - Success: ' + (response?.success || false));
            
            // Check if login was successful
            if (response && response.success && response.token) {
                logToFile('Login successful - Token received: ' + response.token.substring(0, 10) + '...');
                
                // Save both token and session_token for compatibility
                localStorage.setItem('token', response.token);
                localStorage.setItem('session_token', response.token);
                logToFile('Token saved to localStorage (both token and session_token)');
                
                if (response.user) {
                    localStorage.setItem('userData', JSON.stringify(response.user));
                    logToFile('User data saved - UserId: ' + response.user.UserId);
                }
                
                // Then update AuthContext
                login(response.token);
                logToFile('AuthContext.login() called');
                
                // Wait a bit longer to ensure state is fully updated
                setTimeout(() => {
                    logToFile('Navigating to /home');
                    // Use navigate with absolute path
                    const basePath = process.env.REACT_APP_BASE_PATH || '/';
                    const homePath = basePath === '/' ? '/home' : `${basePath}/home`;
                    // Use navigate instead of window.location to avoid page reload
                    navigate(homePath, { replace: true });
                }, 300);
            } else {
                // Login failed - show error
                logToFile('Login failed - Invalid response: ' + JSON.stringify(response));
                console.error('Login failed: Invalid response', response);
            }
        } catch (error) {
            // Login failed - error already shown by toast
            logToFile('Login failed - Error: ' + error.message);
            console.error('Login failed:', error);
            // Don't navigate - stay on login page
        }
    };
    return (
        <div className="main-wrapper main-wrapper3">
            <div className="register-area">
                <div className="container">
                    <div className="register-item register-item2">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="register-item-inner">
                                <h2>{t('Login')} <img src={getImagePath('/images/register-01.png')} alt="" /></h2>
                            </div>
                            <div className="register-item-inner7">
                                <div className='validation-box'>
                                    <div className="register-item-inner4 m-0">
                                        <input type="text"
                                            className="form-control"
                                            id="name"
                                            placeholder={t('Name')}
                                            {...register("username", { required: true })} />
                                        <img src={getImagePath('/images/register-02.png')} alt="" />
                                    </div>
                                    {errors.username && <div className='error-text m-2'>{t('This field is required')}</div>}
                                </div>

                                <div className='validation-box'>
                                    <div className="register-item-inner4 m-0">
                                        <input type="password"
                                            className="form-control"
                                            id="password"
                                            placeholder={t('Password')}
                                            {...register("wachtwoord", { required: true })} />
                                        <img src={getImagePath('/images/register-02.png')} alt="" />
                                    </div>
                                    {errors.wachtwoord && <div className='error-text m-2'>{t('This field is required')}</div>}
                                </div>
                            </div>
                            <div className="register-item-inner8">
                                <Link to='/forgot-password'>{t('Forgot Password')}?</Link>
                            </div>
                            <div className="register-item-inner6">
                                <button type="submit" disabled={login_loading}>{t('Submit')}</button>
                            </div>
                            <div className="register-item-inner6 mt-3">
                                <button onClick={()=>{navigate('/register')}} className='register-button'>
                                    <span>{t('Open an account')}</span>
                                <img src={getImagePath('/images/banner-03.png')} alt=""/>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;